import React, { memo, useState } from 'react'
import { Card, Button, Progress, Spin } from 'antd'
import { PlusOutlined, HistoryOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import PurchaseHistoryModal from './PurchaseHistoryModal'
import './OrganizationUsage.scss'

const OrganizationUsage = memo(({ data, loading, onPurchaseClick }) => {
  const { t } = useTranslation()
  const [historyVisible, setHistoryVisible] = useState(false)

  if (!data && !loading) {
    return null
  }

  const { totalCredits, usedCredits, remainingCredits, consumedPercent, creditValue } = data || {}
  const consumedPercentage = consumedPercent !== undefined
    ? parseFloat(consumedPercent)
    : (totalCredits > 0 ? (usedCredits / totalCredits) * 100 : 0)

  const displayPercentage = typeof consumedPercentage === 'number'
    ? (Number.isInteger(consumedPercentage) ? consumedPercentage : consumedPercentage.toFixed(1))
    : 0

  return (
    <>
      <Card className="organization-usage-card">
        <Spin spinning={loading}>
          <div className="organization-usage-content">
            <div className="credits-consumed-section">
              <div className="credits-display">
                <span className="credits-value">
                  {Math.round(usedCredits || 0).toLocaleString()} of {Math.round(totalCredits || 0).toLocaleString()}
                </span>
                <span className="credits-label">Credits consumed so far</span>
              </div>
              <div className="ai-credit-progress-section">
                <Progress
                  percent={consumedPercentage}
                  strokeColor="#52c41a"
                  showInfo={true}
                  format={() => `${displayPercentage}% Consumed`}
                  className="usage-progress"
                />
              </div>
            </div>
            <div className="credits-remaining-section">
              <div className="remaining-info">
                <span className="remaining-value">
                  {Math.round(remainingCredits || 0).toLocaleString()}
                </span>
                <span className="remaining-label">Credits remaining</span>
              </div>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                <Button
                  type="default"
                  onClick={() => setHistoryVisible(true)}
                >
                  <HistoryOutlined />Purchase History
                </Button>
                <Button
                  type="primary"
                  onClick={onPurchaseClick}
                  disabled={false}
                >
                  <PlusOutlined />Purchase more credits
                </Button>
              </div>
            </div>
          </div>
        </Spin>
      </Card>

      <PurchaseHistoryModal
        visible={historyVisible}
        onClose={() => setHistoryVisible(false)}
      />
    </>
  )
})

OrganizationUsage.displayName = 'OrganizationUsage'

export default OrganizationUsage
